/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FacultyInputs */

const en__field_faculty = /** @type {(inputs: _Field_FacultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department Hochschule Fulda`)
};

const de__field_faculty = /** @type {(inputs: _Field_FacultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich Hochschule Fulda`)
};

/**
* | output |
* | --- |
* | "Department Hochschule Fulda" |
*
* @param {_Field_FacultyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_faculty = /** @type {((inputs?: _Field_FacultyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FacultyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_faculty(inputs)
	return de__field_faculty(inputs)
});